var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { CardContext } from './card';
var Body = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1 1 auto;\n  padding: ", " ", ";\n\n  &.card-body-overlay {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: ", ";\n  }\n\n  &.card-body-overlay-hidden {\n    display: none;\n    visibility: hidden;\n  }\n\n  &.card-body-disabled {\n    filter: blur(5px);\n    -webkit-filter: blur(5px);\n    -moz-filter: blur(5px);\n    -o-filter: blur(5px);\n    -ms-filter: blur(5px);\n  }\n"], ["\n  flex: 1 1 auto;\n  padding: ", " ", ";\n\n  &.card-body-overlay {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: ", ";\n  }\n\n  &.card-body-overlay-hidden {\n    display: none;\n    visibility: hidden;\n  }\n\n  &.card-body-disabled {\n    filter: blur(5px);\n    -webkit-filter: blur(5px);\n    -moz-filter: blur(5px);\n    -o-filter: blur(5px);\n    -ms-filter: blur(5px);\n  }\n"])), function (p) {
  return p.theme.cardSpacerY;
}, function (p) {
  return p.theme.cardSpacerX;
}, function (p) {
  return p.theme.cardBorderRadius;
});

var CardBody = function CardBody(_a) {
  var children = _a.children,
      className = _a.className,
      _b = _a.overlayCard,
      overlayCard = _b === void 0 ? false : _b,
      _c = _a.hideOverlay,
      hideOverlay = _c === void 0 ? false : _c,
      _d = _a.disableChildren,
      disableChildren = _d === void 0 ? false : _d,
      props = __rest(_a, ["children", "className", "overlayCard", "hideOverlay", "disableChildren"]);

  var classes = className ? className + " card-body" : 'card-body';

  if (overlayCard) {
    classes += ' card-body-overlay';
  }

  if (hideOverlay) {
    classes += ' card-body-overlay-hidden';
  }

  if (disableChildren) {
    classes += ' card-body-disabled';
  }

  return React.createElement(CardContext.Consumer, null, function (context) {
    return React.createElement(Body, Object.assign({
      className: classes
    }, context, props), children);
  });
};

export default CardBody;
var templateObject_1;